import Header from "../components/myanwan/header";
import Banner from "../components/myanwan/banner";
import Footer from "../components/myanwan/footer";
import AboutUs from "../components/myanwan/about-us";
import OurPartners from "../components/myanwan/our-partners";
import SearchGrid from "../components/myanwan/search-myanwen";
const MyanWanTemplate = () => {
  return (
    <div>
      <Header />
      <Banner />
      <div className="bg-[#FDF6F0]">
        <SearchGrid />
        <AboutUs />
        <OurPartners />
      </div>
      <Footer />
    </div>
  );
};

export default MyanWanTemplate;
